import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

import { useAuth } from "../../context/AuthContext";
import { importCryptoWallet, getCryptoWallets, createMainAccount } from "../../store/assetsReducer"
import { updateTicketStatus, getTicketStatus } from "../../store/authReducer";

import ImportWallet from './wallet/importWallet';
import CreateWallet from './wallet/createWallet';

import { CUSTODIAN_WALLETS, FIAT_WALLETS } from '../../constants/wallets';

import { WalletType } from "../../types/rail.types";
import type { AppDispatch, RootState } from '../../store';
import { CryptoWalletType, MainAccountType } from "../../types/assets.types"

interface WalletData {
  id?: string;
  type?: string;
  balance: string;
  availableBalance?: string;
  status?: string;
  currency: string;
  address?: string;
}

interface WalletCardProps {
  walletType: MainAccountType;
  isCheckingMainData: boolean;
  // createWallet: (wallet: WalletType) => void;
  showUsdForm:boolean
}
interface ImportCryptoWalletData {
  info: any,
  currency: string,
  endpoint: string
}
const MainAccount: React.FC<WalletCardProps> = ({
  walletType,
  // isCheckingMainData,
  // createWallet,
  // showUsdForm
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, isFullOnboarding } = useAuth();
  // const storage = localStorage.getItem('token')
  const { data:{mainWallets, cryptoWallets, zenusAccount}, status } = useSelector((state: RootState) => state.assets);
  const { data: { cryptoPrices, fiatPrices }, status: rateStatus } = useSelector((state: RootState) => state.setting);
  const { data: ticketStatus} = useSelector((state: RootState) => state.auth.ticketStatus);

  const [walletData, setWalletData] = useState<WalletData>()
  const [openImportWallet, setOpenImportWallet] = useState<boolean>(false);
  const [openCreateWallet, setOpenCreateWallet] = useState<boolean>(false);
  // const [isNewlyCreated, setIsNewlyCreated] = useState<boolean>(false);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [displayBalance, setDisplayBalance] = useState<string>('0')
  // const [currencyUnit, setCurrentUnit] = useState<string>(walletType.shortName)
  // Zenus account now comes from Redux store
  const [isLoadingZenus, setIsLoadingZenus] = useState<boolean>(false);
  const [importData, setImportData] = useState<ImportCryptoWalletData>({
    info: {},
    currency: "",
    endpoint: ""
  })
  // Zenus account is now loaded from Redux store in the dashboard

  // Polling for status updates
  useEffect(() => {
    let interval: NodeJS.Timeout;
    
    if (walletType.currency === 'USD' && zenusAccount?.account &&
        (zenusAccount.account.accountStatus === 'SENT_TO_ZENUS' ||
         zenusAccount.account.accountStatus === 'IN_COMPLIANCE' ||
         zenusAccount.account.accountStatus === 'PENDING')) {

      // Polling is now handled by Redux store
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [walletType.currency, zenusAccount?.account?.accountStatus]);

  useEffect(() => {
    const getWallet = () => {
      // try {
      //   switch (walletType.type) {
      //     case "0":
      //       const walletFiatTmp = mainWallets?.fiatWallets?.data?.find((w: any) =>
      //         w.currency.toLowerCase() === walletType.token.toLowerCase()
      //       );
      //       setWalletData(walletFiatTmp)
      //       break;
      //     case "1":
      //       const walletCustodianTmp = mainWallets?.custodianWallets?.data?.find((w: any) =>
      //         w.currency.toLowerCase() === walletType.token.toLowerCase()
      //       );
      //       setWalletData(walletCustodianTmp)
      //       break;
      //     case "2":
      //       const walletCryptoTmp = cryptoWallets?.data?.find((w: any) =>
      //         w.currency.toLowerCase() === walletType.token.toLowerCase()
      //       );
      //       setWalletData(walletCryptoTmp)
      //       break;
      //   }
      // }
      // catch (error) {
      //   console.log(error);       
      // }
    }
    if(status === "succeeded"){
      getWallet();
    }
  }, [status, mainWallets, cryptoWallets])
  useEffect(() => {
    const getDisplayBalance = (walletData: WalletData) => {
      // if (walletData) {
      //   if (walletType.type === "2") {
      //     const walletBalance = walletData.balance;
      //     if (walletType.token === 'BTC') {
      //       const btcBalance = parseFloat(walletBalance);
      //       if (btcBalance >= 0.099) {
      //         setDisplayBalance(btcBalance.toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
      //         // setCurrentUnit('BTC')
      //       } else {
      //         setDisplayBalance((btcBalance * 1000).toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }));
      //         // setCurrentUnit('mBTC')
      //       }
      //     } else {
      //       setDisplayBalance(parseFloat(walletBalance).toLocaleString());
      //     }
      //   } else {
      //     setDisplayBalance(walletData.availableBalance);
      //   }
      // }
    }
    // getDisplayBalance(walletData)
  }, [walletData])
  // useEffect(()=>{
  //   if(showUsdForm===false && isNewlyCreated===true){
  //     setIsNewlyCreated(false)
  //   }
  // },[showUsdForm])
  const IconComponent = walletType.icon;
  const isFiatWallet = FIAT_WALLETS.find(w => w.currency === walletType.currency) !== undefined;
  const isCustodianWallet = CUSTODIAN_WALLETS.find(w => w.currency === walletType.currency) !== undefined;
  // if ((isFiatWallet || isCustodianWallet) && !isFullOnboarding() && (walletType.type === "0" || walletType.type === "1")) {
  //   return (
  //     <div key={walletType.currency} className="wallet-card">
  //       <IconComponent />
  //       <div className="wallet-card-name">{walletType.name}</div>
  //       <button
  //         className="wallet-create-btn wallet-create-btn-disabled"
  //         disabled={true}
  //         onClick={() => toast.info("You need to complete the full onboarding process to create FIAT wallets.")}
  //       >
  //         Requires Full Onboarding
  //       </button>
  //     </div>
  //   );
  // }

  const handleCreateAccount = async () => {
      if (user.accountType ==="EXPRESS") {
        toast.warning("Not allowed for Express users.")
        return;
      }
      setIsProcessing(true);
      const res = await dispatch(createMainAccount()).unwrap();
      if(res.success){
        dispatch(updateTicketStatus(res.data.ticketId));
        dispatch(getTicketStatus());
        // Map the message to replace "Zenus" with "USD USA Account"
        const mappedMessage = res.data.message
          .replace(/Zenus account request/gi, 'USD USA Account request')
          .replace(/Solicitud de cuenta Zenus/gi, 'Solicitud de cuenta USD USA')
          .replace(/Zenus/gi, 'USD USA Account');
        toast.success(mappedMessage)
      }else{
        const errorMessage = res.data.message
          .replace(/Zenus/gi, 'USD USA Account');
        toast.error(errorMessage)
      }
     setIsProcessing(false); 
  };
  const confirmPermission = () => {
    // if (mainWallets.fiatWallets.data.length < 1 && walletType.type === "0" && walletType.token !== "USD") {
    //   toast.info("Create USA FIAT Wallet First");
    //   setIsNewlyCreated(false);
    //   return false;
    // } else if (mainWallets.fiatWallets.data.length < 1 && walletType.type === "1" && walletType.token !== "USD") {
    //   toast.info("Create USA FIAT Wallet First");
    //   setIsNewlyCreated(false);
    //   return false;
    // }
    //  else {
      return true;
    // }
  }

  const importWallet = async () => {
    try {
      setIsProcessing(true); 
      const result = await dispatch(importCryptoWallet(importData)).unwrap()
        console.log(result);

        if (result.error===null) {
          let cloneCurrency = "";
          if (importData.currency === "BTC") {
            toast.success(`BTC wallet is created successfully!`);
            setOpenImportWallet(false);
            return;
          }
          if (importData.currency === "ETH") {
            cloneCurrency = "USDT_ERC20";
          } else if (importData.currency === "USDT_ERC20") {
            cloneCurrency = "ETH";
          } else if (importData.currency === "TRX") {
            cloneCurrency = "USDT_TRON";
          } else if (importData.currency === "USDT_TRON") {
            cloneCurrency = "TRX";
          } else if (importData.currency === "BNB") {
            cloneCurrency = "USDT_BEP20";
          } else if (importData.currency === "USDT_BEP20") {
            cloneCurrency = "BNB";
          }
          toast.success(`${importData.currency} and ${cloneCurrency} is imported successfully!`);
          setOpenImportWallet(false);
        } else {
          toast.error(result.error || "Failed to import wallet");
        }
    
    } catch (error) {
      toast.error("An error occurred while importing the wallet");
      console.error(error);
    } finally {
      setIsProcessing(false); // Re-enable button
    }
  };
  const create = async (walletType:WalletType) => {
    
    // if(ticketStatus.ticketStatus ==="OPEN" && walletType.currency!=="USD") {
    //   toast.info("The ticket is currently under review!")
    //   return
    // }
    // setIsNewlyCreated(true);
    if (confirmPermission()) {
      // createWallet(walletType)  
    }
    return;
  }

  // if (walletType.currency === 'USD' && walletType.type === "0" && walletData !== undefined) {
  //   return (
  //     <div className={`wallet-card ${isNewlyCreated ? 'newly-created' : ''}`}>
  //       <IconComponent />
  //       <div className="wallet-card-name">{walletType.name}</div>
  //       <Link
  //         to={`/dashboard/wallets`}
  //         className="wallet-card-balance"
  //       >
  //         {walletData.availableBalance} {currencyUnit}
  //       </Link>
  //     </div>
  //   );
  // }

  // if (ticketStatus && ticketStatus.hasTicket && walletType.currency === "USD") {
  //   const hasRailApplication = mainWallets.fiatWallets.data.some((acc: any) =>
  //     acc.type === 'USD' && (acc.status === 'PENDING' || acc.status === 'INCOMPLETE' || acc.status === 'SUBMITTED')
  //   );
  //   return (
  //     <div className={`wallet-card ${isNewlyCreated ? 'newly-created' : ''}`}>
  //       <IconComponent />
  //       <div className="wallet-card-name">{walletType.name}</div>
  //       <button
  //         className="wallet-create-btn wallet-status-btn"
  //         disabled
  //         title={
  //           !ticketStatus.isCompleted
  //             ? "Your wallet request is being reviewed by our compliance team"
  //             : hasRailApplication
  //               ? "Your wallet is being processed by our USA banking partner"
  //               : "Your wallet application is being prepared"
  //         }
  //       >
  //         {!ticketStatus.isCompleted
  //           ? 'IN REVIEW'
  //           : hasRailApplication
  //             ? 'ONBOARDING'
  //             : 'PROCESSING'}
  //       </button>
  //     </div>
  //   );
  // }

  return (
    <>
      {/* Check if Zenus account exists and show balance */}
      {zenusAccount?.account ? (
        <div className="wallet-card">
          <IconComponent />
          <div className="wallet-card-name !font-bold">{walletType.name}</div>
          <Link
            to={`/dashboard/wallets/usd`}
            className="wallet-card-balance"
          >
            ${(zenusAccount.balance || 0).toLocaleString()} USD
          </Link>
          {zenusAccount.account.accountNumber && (
            <div className="text-xs text-gray-500 mt-1">
              Account: ****{zenusAccount.account.accountNumber.slice(-4)}
            </div>
          )}
          {zenusAccount.account.accountStatus && zenusAccount.account.accountStatus !== 'ACTIVE' && (
            <div className="text-xs text-orange-500 mt-1">
              Status: {zenusAccount.account.accountStatus}
            </div>
          )}
        </div>
      ) : (
        <>
          <div className={`wallet-card`}>
            <IconComponent />
            <div className="wallet-card-name !font-bold">{walletType.name}</div>

            {isLoadingZenus ? (
              <button className="wallet-create-btn wallet-create-btn-disabled" disabled={true}>
                Loading...
              </button>
            ) : zenusAccount?.account && zenusAccount.account.accountStatus === 'SENT_TO_ZENUS' ? (
              <button className="wallet-create-btn wallet-create-btn-disabled" disabled={true}>
                Creating Account...
              </button>
            ) : zenusAccount?.account && zenusAccount.account.accountStatus === 'IN_COMPLIANCE' ? (
              <button className="wallet-create-btn wallet-create-btn-disabled" disabled={true}>
                In Review
              </button>
            ) : ticketStatus.accountStatus === "NOT_REQUESTED" ? (
              <button
                className={`wallet-create-btn ${isProcessing ? 'wallet-create-btn-disabled' : ''}`}
                onClick={handleCreateAccount}
                disabled={isProcessing}
              >
                {isProcessing
                  ? 'Processing...'
                  : 'Create Account'}
              </button>
            ) : ticketStatus.accountStatus === "PENDING_REVIEW" ? (
              <button className="wallet-create-btn wallet-create-btn-disabled" disabled={true}>
                Pending
              </button>
            ) : (
              <button
                className={`wallet-create-btn ${isProcessing ? 'wallet-create-btn-disabled' : ''}`}
                onClick={handleCreateAccount}
                disabled={isProcessing}
              >
                {isProcessing
                  ? 'Processing...'
                  : 'Create Account'}
              </button>
            )}
          </div>
          {/* {(openCreateWallet && walletType.type === "3") && (
            <CreateWallet isOpen={openCreateWallet} setOpenCreateWallet={setOpenCreateWallet} setOpenImportWallet={setOpenImportWallet} createWallet={create} walletType={walletType} confirmPermission={confirmPermission} isNewlyCreated={isNewlyCreated} />
          )} */}
          {/* {openImportWallet && (
            <ImportWallet walletType={walletType.token} isOpen={openImportWallet} setOpenImportWallet={setOpenImportWallet} addWallet={importWallet} setImportData={setImportData} />
          )} */}
        </>
      )}
    </>
  );
};

export default MainAccount;